<div class="caption">
  <slot />
</div>

<style>
  .caption {
    padding: 24px;
    font-size: 0.9rem;
  }
</style>